globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.HighChartsChart = (function(){

  HighChartsChart.selector = '[data-plugin="highcharts"]';

  HighChartsChart.init = function($html) {
    $html.find(HighChartsChart.selector).each(function(){
      new HighChartsChart($(this));
    })
  }

  function HighChartsChart($html) {
    this.$html = $html;
    this.options = $html.data("chart-options");
    this.type = $html.data("chart-type");
    this.setDateOptions();
    this.init();
  }

  HighChartsChart.prototype = {
    init: function() {
      chart = this;
      chart.setExtraOptions();
      chart.$html.highcharts(chart.options);

      if(chart.type == "map") {
        chart.setMapOptions();
      }

      chart.setDateOptions();
    },
    setDateOptions: function() {
      Highcharts.setOptions({
        lang: appCustomerSpace.Modules.Charts.lang.t('highcharts')
      })
    },
    setExtraOptions: function() {
      var chart = this;

      chart.setColors();

      if(chart.$html.hasClass("chart-seconds-formatter")) {
        chart.formatToSeconds();
      }
    },
    setMapOptions: function() {
      var chart = this;

      chart.options = $.extend(true, {
        series: [{ mapData: Highcharts.maps['custom/world'] }]
      }, chart.options)

      $.fn.highcharts.apply(chart.$html, ["Map", chart.options]);
    },
    setColors: function() {
      var chart = this;

      if(chart.options && chart.options.colors) {
        chart.options.plotOptions = { series: { colors: chart.options.colors } }
      } else {
        chart.options.plotOptions = { series: { color: helpers.white_space.main_color || '#7CA6E6' } }
      }
    },
    formatToSeconds: function() {
      var chart = this;

      function secondsToMinutes(seconds) {
        var total = seconds;
        var minutes = Math.floor(total / 60);
        var seconds = total - minutes * 60;
        return `${minutes > 0 ? `${minutes}min` : ""} ${seconds > 0 ? `${seconds}s` : ""}`
      }

      chart.options = $.extend(true, {
        tooltip: {
          formatter: function() {
            return `<span style="font-size: 10px">${Highcharts.dateFormat('%B %Y', this.x)}</span><br/><span style="color:${this.series.color}">\u25CF</span>${this.series.name}: ${secondsToMinutes(this.y)}`
          }
        },
        yAxis: {
          labels: {
            formatter: function() {
              return secondsToMinutes(this.value);
            }
          }
        },
      }, chart.options)
    },
  }

  return HighChartsChart;

})();
